import React from 'react'
import { BookOpen } from 'lucide-react'

export interface TaxonomyOption {
  id: string
  name: string
  description: string
}

export const TAXONOMY_OPTIONS: TaxonomyOption[] = [
  { id: 'anzsrc-2020', name: 'ANZSRC 2020', description: 'Australian and New Zealand Standard Research Classification' },
  { id: 'openalex-topics', name: 'OpenAlex Topics', description: 'OpenAlex hierarchical topic taxonomy' },
  { id: 'isced-f-2013', name: 'ISCED-F 2013', description: 'International Standard Classification of Education - Fields' },
  { id: 'cip-2020', name: 'CIP 2020', description: 'Classification of Instructional Programs' },
  { id: 'ddc-summaries', name: 'DDC Summaries', description: 'Dewey Decimal Classification Summaries' },
]

interface TaxonomySwitcherProps {
  activeTaxonomyId: string
  onSwitch: (taxonomyId: string) => void
}

const TaxonomySwitcher: React.FC<TaxonomySwitcherProps> = ({ activeTaxonomyId, onSwitch }) => {
  const active = TAXONOMY_OPTIONS.find(t => t.id === activeTaxonomyId)

  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-2">
      <div className="flex items-center gap-2 text-sm text-gray-500">
        <BookOpen className="w-4 h-4 text-acad-500" />
        <span className="font-medium">Taxonomy:</span>
      </div>
      <div className="flex-1 max-w-md">
        <select
          value={activeTaxonomyId}
          onChange={(e) => onSwitch(e.target.value)}
          className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm bg-white
                     focus:outline-none focus:ring-2 focus:ring-acad-500 focus:border-acad-500
                     hover:border-acad-300 transition-colors"
        >
          {TAXONOMY_OPTIONS.map(option => (
            <option key={option.id} value={option.id}>
              {option.name}
            </option>
          ))}
        </select>
      </div>
      {active && (
        <p className="text-xs text-gray-400 hidden lg:block">{active.description}</p>
      )}
    </div>
  )
}

export default TaxonomySwitcher
